var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8485 21.7445H15.8965C14.8124 21.7445 14.0107 20.835 14.1048 19.7114L15.7598 0.122887H23.6751L21.8485 21.7445Z",
    fill: "#FFC794"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2433 21.7445L12.9357 13.5499H3.61744C2.53332 13.5499 1.57675 14.4594 1.48261 15.583L0.961807 21.7445H12.2433Z",
    fill: "#FFC794"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8586 33.4436H12.9433L12.1279 43.0898C12.0338 44.2119 12.8355 45.1229 13.9196 45.1229H19.8716L20.8586 33.4436Z",
    fill: "#FFC794"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3766 11.8022H32.2919L33.1073 2.15599C33.2014 1.03391 32.3997 0.122887 31.3156 0.122887H25.3636L24.3766 11.8022Z",
    fill: "#FFC794"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.007 23.5013L32.3147 31.6959H41.6329C42.717 31.6959 43.6736 30.7864 43.7677 29.6628L44.2886 23.5013H33.007Z",
    fill: "#FFC794"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4374 21.7445L45.1297 13.5499H26.2078C25.1237 13.5499 24.1671 14.4594 24.0729 15.583L23.5521 21.7445H44.4374Z",
    fill: "#FFC794"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4033 23.5013H29.3553C30.4395 23.5013 31.2412 24.4108 31.147 25.5344L29.492 45.1229H21.5767L23.4033 23.5013Z",
    fill: "#FFC794"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.82211 23.4117L0.12973 31.6063H19.0517C20.1358 31.6063 21.0924 30.6968 21.1865 29.5732L21.7073 23.4117H0.82211Z",
    fill: "#FFC794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlus);
export default __webpack_public_path__ + "static/media/logo_plus.11b9e68b26a39717e3b87ac14061f9a1.svg";
export { ForwardRef as ReactComponent };